var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import RefreshCwSvg from './refresh-cw-01.icon.svg';
export const RefreshCwIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: RefreshCwSvg }));
_react_refresh_temp_1 = RefreshCwIcon;
$RefreshReg$(_react_refresh_temp_1, "RefreshCwIcon");
